module.exports = __webpack_public_path__ + "img/zjs.6e2ddb5c.png";